import React from 'react';

import { SVGComponentProps } from './svg.types';

const NewbieIconSVG = ({ size = '1em', wrapperClass, ...otherProps }: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <mask id="path-1-inside-1" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48 16C48 8.26801 41.732 2 34 2H14C6.26801 2 0 8.26801 0 16V28C0 41.2548 10.7452 52 24 52C37.2548 52 48 41.2548 48 28V16Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 16C48 8.26801 41.732 2 34 2H14C6.26801 2 0 8.26801 0 16V28C0 41.2548 10.7452 52 24 52C37.2548 52 48 41.2548 48 28V16Z"
          fill="#EEF1FC"
        />
        <path
          d="M14 5H34V-1H14V5ZM3 28V16H-3V28H3ZM24 49C12.402 49 3 39.598 3 28H-3C-3 42.9117 9.08831 55 24 55V49ZM45 28C45 39.598 35.598 49 24 49V55C38.9117 55 51 42.9117 51 28H45ZM45 16V28H51V16H45ZM34 5C40.0751 5 45 9.92487 45 16H51C51 6.61116 43.3888 -1 34 -1V5ZM14 -1C4.61116 -1 -3 6.61116 -3 16H3C3 9.92487 7.92487 5 14 5V-1Z"
          fill="#FFD321"
          mask="url(#path-1-inside-1)"
        />
        <path
          d="M14 5H34V-1H14V5ZM3 28V16H-3V28H3ZM24 49C12.402 49 3 39.598 3 28H-3C-3 42.9117 9.08831 55 24 55V49ZM45 28C45 39.598 35.598 49 24 49V55C38.9117 55 51 42.9117 51 28H45ZM45 16V28H51V16H45ZM34 5C40.0751 5 45 9.92487 45 16H51C51 6.61116 43.3888 -1 34 -1V5ZM14 -1C4.61116 -1 -3 6.61116 -3 16H3C3 9.92487 7.92487 5 14 5V-1Z"
          fill="#9BADEE"
          mask="url(#path-1-inside-1)"
        />
        <path
          d="M17.878 30.8768C17.3316 31.4048 16.3609 32.6978 15.7739 33.8795C14.9401 35.5585 14.8184 37.0994 14.8184 37.9619C15.7614 37.6703 16.7013 37.3787 17.6443 37.0902C18.478 38.0601 19.3118 39.03 20.1455 40C20.2173 39.0239 20.4546 37.5137 21.2478 35.847C21.9129 34.4535 22.7341 33.4406 23.3586 32.7837C22.5124 32.8236 21.3127 32.688 20.119 32.2153C19.1707 31.8397 18.4276 31.2145 17.878 30.8768Z"
          fill="#627FE5"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M30.5993 30.5101C31.2332 31.0349 32.273 32.0356 33.0443 33.601C33.8842 35.3045 33.9967 36.8515 33.9998 37.6833C33.0568 37.3917 32.1169 37.1001 31.1738 36.8116C30.3401 37.7815 29.5064 38.7515 28.6727 39.7214C28.5946 38.7146 28.3542 37.2137 27.5704 35.5685C27.0489 34.4727 26.4338 33.6225 25.9092 33.0055C26.643 32.8428 27.6609 32.5359 28.7445 31.9067C29.5376 31.4432 30.1496 30.9398 30.5993 30.5101Z"
          fill="#627FE5"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M23.783 33.233C29.1861 33.233 33.5661 28.9276 33.5661 23.6165C33.5661 18.3055 29.1861 14 23.783 14C18.38 14 14 18.3055 14 23.6165C14 28.9276 18.38 33.233 23.783 33.233Z"
          fill="#9BADEE"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M23.783 31.8027C28.3824 31.8027 32.1109 28.1376 32.1109 23.6165C32.1109 19.0954 28.3824 15.4304 23.783 15.4304C19.1836 15.4304 15.4551 19.0954 15.4551 23.6165C15.4551 28.1376 19.1836 31.8027 23.783 31.8027Z"
          fill="#627FE5"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M23.7838 29.9273C27.3295 29.9273 30.2038 27.1018 30.2038 23.6165C30.2038 20.1312 27.3295 17.3058 23.7838 17.3058C20.2381 17.3058 17.3638 20.1312 17.3638 23.6165C17.3638 27.1018 20.2381 29.9273 23.7838 29.9273Z"
          fill="#9BADEE"
          stroke="black"
          strokeWidth="0.4"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="2"
          width="48"
          height="50"
        >
          <mask id="path-8-inside-2" mask-type="luminance" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M48 16C48 8.26802 41.732 2 34 2H14C6.26801 2 0 8.26801 0 16V28.9231C0 41.6681 10.7452 52 24 52C37.2548 52 48 41.6681 48 28.9231V16Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48 16C48 8.26802 41.732 2 34 2H14C6.26801 2 0 8.26801 0 16V28.9231C0 41.6681 10.7452 52 24 52C37.2548 52 48 41.6681 48 28.9231V16Z"
            fill="#FFF3E5"
          />
          <path
            d="M14 5H34V-1H14V5ZM3 28.9231V16H-3V28.9231H3ZM24 49C12.29 49 3 39.9014 3 28.9231H-3C-3 43.4348 9.2003 55 24 55V49ZM45 28.9231C45 39.9014 35.71 49 24 49V55C38.7997 55 51 43.4348 51 28.9231H45ZM45 16V28.9231H51V16H45ZM34 5C40.0751 5 45 9.92487 45 16H51C51 6.61116 43.3888 -1 34 -1V5ZM14 -1C4.61116 -1 -3 6.61115 -3 16H3C3 9.92486 7.92487 5 14 5V-1Z"
            fill="#EDC474"
            mask="url(#path-8-inside-2)"
          />
        </mask>
        <g mask="url(#mask0)">
          <rect
            opacity="0.2"
            x="-16"
            y="48"
            width="72"
            height="20"
            transform="rotate(-45 -16 48)"
            fill="white"
          />
        </g>
      </svg>
    </span>
  );
};

export default NewbieIconSVG;
